import React from 'react';
import './App.css';
import AppRouter from './navigation/AppRouter';

const App = () => {
  
  return (
    <div>
        <AppRouter />
    </div>
  );
};

export default App;
